// A vendor payment is either settling bills or sitting as an advance. There are two kinds,
// but three vocabularies had grown up around them:
//
//   vendor_payments.payment_type  ->  'payment' | 'advance'      (the DB enum)
//   the Add form                  ->  'bill_payment' | 'advance_payment'
//   the Edit form                 ->  both of the above, listed together as three options
//
// The Edit page therefore offered a phantom third type, and because it fed the stored enum
// straight into a dropdown built from the form vocabulary, editing an advance selected
// nothing at all. This module is the single vocabulary; the API accepts either spelling on
// the way in (see paymentTypeMap in vendorController).

export const PAYMENT_TYPES = [
    { value: 'bill_payment', label: 'Bill Payment' },
    { value: 'advance_payment', label: 'Advance Payment' },
];

// Stored enum (or a legacy form value) -> the value the forms use.
export const toFormPaymentType = (stored) => {
    const value = String(stored || '').toLowerCase();
    if (value === 'advance' || value === 'advance_payment') return 'advance_payment';
    if (value === 'payment' || value === 'bill_payment') return 'bill_payment';
    return '';
};

export const getPaymentTypeLabel = (type) => {
    const match = PAYMENT_TYPES.find(t => t.value === toFormPaymentType(type));
    return match ? match.label : (type || '-');
};

export const isBillPayment = (type) => toFormPaymentType(type) === 'bill_payment';
